import React from 'react'

import { safeReactLazy } from 'utils/safeReactLazy'
import { isWebViewRoute } from 'utils/router/tools'

//
// ─── GLOBAL MODALS ──────────────────────────────────────────────────────────────
//

const AccountErrorModal = safeReactLazy(
  () => import('common/core/controllers/AccountErrorModal/AccountErrorModal'),
)
const CreateUserFieldModal = safeReactLazy(
  () => import('common/fields/components/CreateFieldModal/CreateUserFieldModal'),
)
const CreateGlobalFieldModal = safeReactLazy(
  () => import('common/fields/components/CreateFieldModal/CreateGlobalFieldModal'),
)

const CreateTagModal = safeReactLazy(
  () => import('common/tags/controllers/TagsTable/components/CreateTagModal/CreateTagModal'),
)
const BotTimezoneModal = safeReactLazy(
  () => import('common/settings/components/BotTimezoneModal/BotTimeZoneModal'),
)
const ConnectChannelModalController = safeReactLazy(
  () => import('common/core/controllers/ConnectChannelModal/ConnectChannelModalController'),
)
const CreateCustomEventModalController = safeReactLazy(
  () => import('common/events/controllers/CreateCustomEventModal/CreateCustomEventModalController'),
)

const BlockedAccountModal = safeReactLazy(
  () => import('apps/account/components/BlockedAccountModal'),
)
const FBPolicyEnforcementModalController = safeReactLazy(
  () =>
    import('common/core/controllers/FBPolicyEnforcementModal/FBPolicyEnforcementModalController'),
)
const NotifyAdminMigrationModal = safeReactLazy(
  () =>
    import(
      'common/settings/components/SettingsPanel/NotifyAdminMigration/NotifyAdminMigrationModal'
    ),
)
const BusinessDomainModals = safeReactLazy(
  () => import('apps/email/components/BusinessDomain/BusinessDomainModals'),
)
const CreateKeywordWithSystemNameModal = safeReactLazy(
  () =>
    import(
      'apps/keywords/components/CreateKeywordWithSystemNameModal/CreateKeywordWithSystemNameModal'
    ),
)
const IgPreviewModal = safeReactLazy(
  () => import('common/builder/components/manager/flow/IgPreviewModal/IgPreviewModal'),
)

const HowToCreateTopicsModal = safeReactLazy(
  () => import('common/oneTimeNotify/components/HowToCreateTopicsModal/HowToCreateTopicsModal'),
)
const InstagramTopicsModal = safeReactLazy(
  () => import('common/oneTimeNotify/components/InstagramTopicsModal/InstagramTopicsModal'),
)
const KeywordsWarningModal = safeReactLazy(
  () => import('apps/keywords/components/KeywordWarningModal/KeywordWarningModal'),
)
const IgChangeAccountTypeErrorModal = safeReactLazy(
  () =>
    import(
      'common/settings/components/IgChangeAccountTypeErrorModal/IgChangeAccountTypeErrorModal'
    ),
)
const RecurringNotificationWizard = safeReactLazy(() =>
  import(
    'apps/dashboard/components/RnLearning/components/FirstRecurringNotificationOnboarding/Components/FirstRecurringNotificationModal/components/RecurringNotificationWizard/RecurringNotificationWizard'
  ).then((module) => ({ default: module.RecurringNotificationWizard })),
)

const IGRNReleaseModal = safeReactLazy(() => import('common/modals/IGRNReleaseModal'))

const RefreshPermissionModal = safeReactLazy(
  () => import('common/core/components/RefreshPermissionModal/RefreshPermissionModal'),
)

const CompactSettingsModal = safeReactLazy(
  () => import('common/core/controllers/CompactSettingsModal'),
)

const OnboardingModal = safeReactLazy(
  () => import('apps/whatsApp/components/MarketingLite/OnboardingModal'),
)

const AiCommunications = safeReactLazy(() => import('apps/aiCommunications'))

const WaCoexistenceContactImportModal = safeReactLazy(
  () =>
    import(
      'apps/whatsApp/components/WaCoexistenceContactImportModal/WaCoexistenceContactImportModal'
    ),
)

const FollowReplyIneligibleModal = safeReactLazy(
  () => import('apps/followReply/components/FollowReplyIneligibleModal/FollowReplyIneligibleModal'),
)

const ManageProfilesModal = safeReactLazy(
  () => import('common/core/components/ManageProfilesModal/ManageProfilesModal'),
)

const TikTokFollowWelcomeSetupModal = safeReactLazy(
  () =>
    import(
      'apps/tiktokFollowWelcome/components/TikTokFollowWelcomeSetupModal/TikTokFollowWelcomeSetupModal'
    ),
)


import { useAppSelector } from 'reduxTyped'

import { Notifications } from 'apps/chat/controllers/notifications/Notifications'
import { FlowPickerModal } from 'apps/flowPicker/components/FlowPickerModal/FlowPickerModal'
import { InstagramChangeConnectionModal } from 'apps/followReply/components/InstagramChangeConnectionModal/InstagramChangeConnectionModal'
import SMSConnectionModalNew from 'apps/sms/components/connectionModal/SMSConnectionModalNew'
import EmailVerificationController from 'common/core/components/EmailVerification/EmailVerificationController'
import { getCurrentAccountID } from 'common/core/selectors/appSelectors'
import AvailableFieldsInitializer from 'common/fields/components/AvailableFieldsInitializer'

export const ModalsList = () => {
  const accountId = useAppSelector(getCurrentAccountID)

  if (!accountId || isWebViewRoute()) {
    return null
  }

  return (
    <React.Suspense fallback={null}>
      <IGRNReleaseModal />
      <EmailVerificationController />
      <Notifications />
      <AccountErrorModal />
      <CreateUserFieldModal />
      <CreateGlobalFieldModal />
      <IgPreviewModal />
      <CreateTagModal />
      <ConnectChannelModalController />
      <CompactSettingsModal />
      <CreateCustomEventModalController />
      <SMSConnectionModalNew />
      <BusinessDomainModals />
      <HowToCreateTopicsModal />
      <BlockedAccountModal />
      <NotifyAdminMigrationModal />
      <CreateKeywordWithSystemNameModal />
      <KeywordsWarningModal />
      <InstagramTopicsModal />
      <IgChangeAccountTypeErrorModal />
      <RecurringNotificationWizard />
      <BotTimezoneModal />
      <FBPolicyEnforcementModalController />
      <AvailableFieldsInitializer />
      <FlowPickerModal />
      <RefreshPermissionModal />
      <AiCommunications />
      <WaCoexistenceContactImportModal />
      <OnboardingModal />
      <FollowReplyIneligibleModal />
      <InstagramChangeConnectionModal />
      <ManageProfilesModal />
      <TikTokFollowWelcomeSetupModal />
    </React.Suspense>
  )
}
